module.exports = __webpack_public_path__ + "img/thumbnail_GalapagosGiantTortoise_j_normal.f660e926.png";